import { Avatar, Button, Card, Image, Tag } from "antd";
import { PlusIcon, SearchIcon } from "../../../../../../atoms/CustomIcons";
import PinIcon from "../../../../../../atoms/CustomIcons/PinIcon";

export default function ProfileSidebar() {
  return (
    <>
      <Card className="profileSidebar">
        <h4>Crew members</h4>
        <div
          className="sidebarInfo"
          style={{ flexDirection: "column", gap: "0px" }}
        >
          <h6
            style={{
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: "12px",
            }}
          >
            Crew leader
          </h6>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              <Avatar src="/images/dummy/checkList_dp_1.png" size={24} />
              Jake R.
            </div>
            <div className="infoWrapper">
              <Tag>
                <PinIcon style={{ marginRight: "4px" }}></PinIcon> 5678
              </Tag>
            </div>
            <div className="infoWrapper" style={{ fontWeight: "600" }}>
              $40 / hr
            </div>
          </div>

          <h6
            style={{
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: "12px",
            }}
          >
            Regular technicians
          </h6>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              <Avatar src="/images/dummy/checkList_dp_3.svg" size={24} />
              Carlos E.
            </div>
            <div className="infoWrapper">
              <Tag>
                {" "}
                <PinIcon style={{ marginRight: "4px" }}></PinIcon> 2311{" "}
              </Tag>
            </div>
            <div className="infoWrapper" style={{ fontWeight: "600" }}>
              $30 / hr
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              <Avatar src="/images/dummy/checkList_dp_2.png" size={24} />
              Tyler J.
            </div>
            <div className="infoWrapper">
              <Tag>
                {" "}
                <PinIcon style={{ marginRight: "4px" }}></PinIcon> 1265{" "}
              </Tag>
            </div>
            <div className="infoWrapper" style={{ fontWeight: "600" }}>
              $30 / hr
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              <Avatar src="/images/dummy/checkList_dp_3.svg" size={24} />
              Mateo L.
            </div>
            <div className="infoWrapper">
              <Tag>
                {" "}
                <PinIcon style={{ marginRight: "4px" }}></PinIcon> 2612{" "}
              </Tag>
            </div>
            <div className="infoWrapper" style={{ fontWeight: "600" }}>
              $30 / hr
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="profileSidebar"
        onClick={() =>
          window.open(
            "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
            "_blank"
          )
        }
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList inner_card doc_extra_card">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Training & assess...</span>
            </div>
            <div className="documentImage">
              <Image
                src="/images/dummy/doc_img_sample.png"
                preview={false}
                width={"100%"}
              />
            </div>
          </Card>
        </div>
      </Card>
    </>
  );
}
